import { DataTableColumn } from '../../data-table.config';
import { DataTableColumnTextFilter } from '../data-table-column-text/data-table-column-text.config';

export class DataTableColumnBadge extends DataTableColumn {
  value!: (item: any) => string | number | null | undefined;
  badgeClass!: (item: any) => string;

  constructor(params: {
    attribute: string;
    header: string;
    value: (item: any) => string | number | null | undefined;
    badgeClass: (item: any) => string;
    filter?: DataTableColumnTextFilter;
    filterOptionsSource?: string;
    width?: string;
    style?: any;
    sortable?: boolean;
  }) {
    super();
    Object.assign(this, params);
  }
}
